import { render, staticRenderFns } from "./chat-photo-select.vue?vue&type=template&id=a5bf96f0&scoped=true&"
import script from "./chat-photo-select.vue?vue&type=script&lang=js&"
export * from "./chat-photo-select.vue?vue&type=script&lang=js&"
import style0 from "./chat-photo-select.vue?vue&type=style&index=0&id=a5bf96f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bf96f0",
  null
  
)

export default component.exports